module.exports = __webpack_public_path__ + "static/img/no-learning-content.32a0b9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/person/no-learning-content.png
// module id = bCmW
// module chunks = 1